document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
    });

    nav.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      }
    });
  }

  document.querySelectorAll('.product-gallery').forEach((gallery) => {
    const mainImage = gallery.querySelector('[data-gallery-main]');
    const thumbnails = Array.from(
      gallery.querySelectorAll('[data-gallery-thumb]')
    );

    if (!mainImage || thumbnails.length === 0) return;

    let currentIndex = thumbnails.findIndex(
      (thumbnail) => thumbnail.getAttribute('aria-pressed') === 'true'
    );

    if (currentIndex < 0) currentIndex = 0;

    function showImage(index) {
      currentIndex =
        (index + thumbnails.length) % thumbnails.length;

      const selectedThumbnail = thumbnails[currentIndex];

      /*
       * Shopify's original srcset was preventing the selected
       * thumbnail from replacing the main image.
       */
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.removeAttribute('width');
      mainImage.removeAttribute('height');

      mainImage.src = selectedThumbnail.dataset.imageSrc;
      mainImage.alt = selectedThumbnail.dataset.imageAlt || '';

      thumbnails.forEach((thumbnail) => {
        thumbnail.setAttribute('aria-pressed', 'false');
      });

      selectedThumbnail.setAttribute('aria-pressed', 'true');

      thumbnails.forEach((thumbnail) => {
  thumbnail.setAttribute('aria-pressed', 'false');
});

selectedThumbnail.setAttribute('aria-pressed', 'true');
    }

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        showImage(index);
      });
    });

    const previousButton = gallery.querySelector('[data-gallery-prev]');
    const nextButton = gallery.querySelector('[data-gallery-next]');

    if (previousButton) {
      previousButton.addEventListener('click', () => {
        showImage(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        showImage(currentIndex + 1);
      });
    }

    const mainBox = gallery.querySelector('.product-gallery__main');
    let touchStartX = 0;

    if (mainBox) {
      mainBox.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      mainBox.addEventListener(
        'touchend',
        (event) => {
          const touchEndX = event.changedTouches[0].clientX;
          const distance = touchEndX - touchStartX;

          if (Math.abs(distance) < 50) return;

          if (distance < 0) {
            showImage(currentIndex + 1);
          } else {
            showImage(currentIndex - 1);
          }
        },
        { passive: true }
      );
    }
  });
});